import { GetTalksResponse, Thematic, useGetTalksMutation, useGetThematicsMutation } from '@services';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

export const useCauseriesTalkListPageVM = () => {
    const { thematicId } = useParams();
    const [talks, setTalks] = useState<GetTalksResponse>([]);
    const [thematic, setThematic] = useState<Thematic | undefined>(undefined);

    const [getThematics, { isLoading: isLoadingThematics, data, error: thematicsError }] = useGetThematicsMutation();
    const [getTalks, { isLoading: isTalksLoading, data: talksData, error: talksError }] = useGetTalksMutation();

    useEffect(() => {
        if (!thematicId) return;
        getThematics(undefined);
        getTalks({ thematicId: parseInt(thematicId) });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [thematicId]);

    useEffect(() => {
        if (data && thematicId) {
            setThematic(data.find((thematic) => thematic.id === parseInt(thematicId)));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadingThematics, data, thematicsError]);

    useEffect(() => {
        if (talksData) {
            setTalks(talksData);
        }
    }, [isTalksLoading, talksData, talksError]);

    return {
        isLoading: isTalksLoading || isLoadingThematics,
        talks,
        thematic
    };
};
